import { changeAppState } from "../../../../../../common/appState";
import { fetchPost } from "../../../../../../common/util/fetch";
import { PresentBoxKey } from "../../../../../zApps/Layout/Login/MyPage/components/OpenableCards/ItemsCard/items/ItemClass/PresentBox";
import { RegisteredEnvelopeKey } from "../../../../../zApps/Layout/Login/MyPage/components/OpenableCards/ItemsCard/items/ItemClass/RegisteredEnvelope/RegisteredEnvelope";
import { User } from "../../../../User/types";
import { getMessagesPerDays } from "../../getMessagesPerDay";
import { Message, MessagesPerDays, ReadMessageResponse } from "../../types";

type OpenPresentResponse = {
    messages: Message[];
    user: User;
};
export async function openPresent(
    presenterUserId: number,
    openerUserId: number,
    messageNo: number,
    presentKey: string,
    coins: number,
    presentQuantity: number,
    num: number,
    setMessages: (messages: MessagesPerDays) => void,
    setCurrentlySentMessageNo: (messageId: number) => void
): Promise<void> {
    const result = await fetchPost<
        {
            presenterUserId: number;
            openerUserId: number;
            messageNo: number;
            presentKey: string;
            coins: number;
            presentQuantity: number;
            num: number;
        },
        OpenPresentResponse
    >("api/PresentBox/OpenPresent", {
        presenterUserId,
        openerUserId,
        messageNo,
        presentKey,
        coins,
        presentQuantity,
        num,
    });
    if ("error" in result) {
        return;
    }
    setMessages(getMessagesPerDays(result.messages));
    setCurrentlySentMessageNo(
        Math.max(...result.messages.map(m => m.messageNo))
    );
    changeAppState("user", result.user);
}

export async function readMessage(
    fromUserId: number,
    toUserId: number,
    messageNo: number,
    num: number
): Promise<ReadMessageResponse> {
    return fetchPost<
        {
            fromUserId: number;
            toUserId: number;
            messageNo: number;
            num: number;
        },
        ReadMessageResponse
    >("api/Message/ReadMessage", { fromUserId, toUserId, messageNo, num });
}

export async function readMessages(
    fromUserId: number,
    toUserId: number,
    messageNos: number[],
    num: number
): Promise<ReadMessageResponse> {
    return fetchPost<
        {
            fromUserId: number;
            toUserId: number;
            messageNos: number[];
            num: number;
        },
        ReadMessageResponse
    >("api/Message/ReadMessages", { fromUserId, toUserId, messageNos, num });
}

export type CoinsForPresentTypes = Partial<{
    [key in PresentBoxKey | RegisteredEnvelopeKey]: number;
}>;
type OpenAllUnopenedPresentsResponse = {
    messages: Message[];
    user: User;
};
export async function OpenAllUnopenedPresents(
    presenterUserId: number,
    openerUserId: number,
    coinsForPresentTypes: CoinsForPresentTypes,
    setMessages: (messages: MessagesPerDays) => void,
    setCurrentlySentMessageNo: (messageId: number) => void,
    num: number
): Promise<void> {
    const result = await fetchPost<
        {
            presenterUserId: number;
            openerUserId: number;
            coinsForPresentTypes: CoinsForPresentTypes;
            num: number;
        },
        OpenAllUnopenedPresentsResponse
    >("api/PresentBox/OpenAllUnopenedPresents", {
        presenterUserId,
        openerUserId,
        coinsForPresentTypes,
        num,
    });
    if ("error" in result) {
        return;
    }
    setMessages(getMessagesPerDays(result.messages));
    setCurrentlySentMessageNo(
        Math.max(...result.messages.map(m => m.messageNo))
    );
    changeAppState("user", result.user);
}
